import { useState } from 'react'
import Popover from '../primitives/Popover'
import styles from './RmInfo.module.css'

const RM_DESCRIPTION =
  'Over the course of the challenge, you will earn Relentless Miles (RMs) that represent how far you have traveled'

export default function RmInfo() {
  const [open, setOpen] = useState(false)

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      side='bottom'
      align='end'
      className={styles.popover}
      trigger={
        <button
          type='button'
          className={styles.trigger}
          onClick={(event) => event.stopPropagation()}
        >
          What are RMs?
        </button>
      }
    >
      <p className={styles.description}>{RM_DESCRIPTION}</p>
    </Popover>
  )
}
